// Fallback for when the HTTP fetch of the matching file under
// src/assets/data/print-labels-data/sheet/ fails. GENERATED FROM THAT FILE - keep
// the two identical: a drifted copy means a fetch failure quietly prints a
// different label, which is the worst moment to find the difference.
export const DEFAULT_SHEET_TEMPLATE: string = `
<!--
  Full-sheet copier label, NO QR CODE. ONE OF THESE PRINTS PER PHYSICAL CONTAINER.

  Used whenever PrintService.usesQrSheet is false — a legacy log with no item
  rows, or a facility with browser QR turned off. See qr-large-label-template.html
  for the QR-carrying twin, which PrintService selects instead whenever there are
  item rows and QR is on.

  {{containerCaption}} is filled per item by PrintService.fillItemSlots and
  emptied on a legacy log with no item rows. Every text row keeps the
  label-line class: PrintService.resizeFont shrinks those to fit the page width.
-->
<div class="label">
  <div class="label-line line-1">{{jobName}}</div>
  <div class="label-line line-2">JOB# {{jobNumber}}</div>
  <div class="label-line line-3">PO# {{poNumber}}</div>
  <div class="label-line line-4">{{qtyUnits}}</div>
  <div class="label-line line-container">{{containerCaption}}</div>
  <div class="label-line line-5">{{contact}}</div>
  <div class="label-line line-6">{{dateIn}}</div>
</div>
`;
